const isEmpty = data =>
  !data
    || (!Array.isArray(data) && !data.value && !data.passState)
    || (Array.isArray(data) && !data.some(d => d.value || d.passState));

export default isEmpty;